import React from 'react';
import './Fireworks.css';

export const Fireworks = ({ className }) => {
    return (
        <div className="fireworks-container">
                <div className={"firework " + className}></div>
                <div className={"firework " + className}></div>
                <div className={"firework " + className}></div>
        </div>
    );
}